import {Component, OnInit} from '@angular/core';
import {FeatureService} from "../../services/feature.service";
import {CreateFeatureDto} from "../../dto/create-feature.dto";
import {Feature} from "../../model/feature.model";
import {FeatureGroup, FeatureGroupService} from '../../../../feature-group';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import { IonHeader, IonToolbar, IonTitle, IonContent, IonSelect, IonSelectOption } from '@ionic/angular/standalone';
import {SexyModule} from '@qid/sexy';
import {SuperButtonComponent, SuperInputComponent} from '@qid/super';
import {ListFeatureComponent} from '../../components/list-feature/list-feature.component';

@Component({
  selector: 'app-create-feature',
  templateUrl: './create-feature.page.html',
  styleUrls: ['./create-feature.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    SexyModule,
    SuperButtonComponent,
    SuperInputComponent,
    ListFeatureComponent,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonSelect,
    IonSelectOption
  ]
})
export class CreateFeaturePage implements OnInit {

  featureDto: CreateFeatureDto = new CreateFeatureDto()
  featureGroups: FeatureGroup[] = [];

  constructor(private featureService: FeatureService,
              private featureGroupService: FeatureGroupService
  ) {
  }

  ngOnInit() {
  }

  ionViewDidEnter() {
    this.fetchFeatureGroups();
  }

  async fetchFeatureGroups() {
    this.featureGroups = await this.featureGroupService.readAll();
  }

  create = async () => {
    await this.featureService.create(this.featureDto)
  }

  update = async () => {
    await this.featureService.update(this.featureDto)
  };


  getOptions(featureGroups: FeatureGroup[]) {

  }

  updateFeature(feature : Feature) {
    if(!feature){
      return
    }
    this.featureDto._id = feature._id;
    this.featureDto.featureGroup = feature.featureGroup?._id || null;
    this.featureDto.name = feature.name;
    this.featureDto.description = feature.description;
    this.featureDto.priceModel = feature.priceModel
    this.featureDto.defaultQuota = feature.defaultQuota;
    this.featureDto.defaultPrice = feature.defaultPrice

  }

  resetDto() {
    this.featureDto = new CreateFeatureDto()
  }
}
